import styled from "styled-components";

export const Container = styled.div`
  label {
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    &:first-child {
      margin-top: 5px;
    }
    &.error {
      color: #d44c4c;
    }
  }

  .infoBlock {
    background: #f7f5fb;
    border-radius: 4px;
    padding: 12px 8px;
    margin-bottom: 16px;

    .infoLabel {
      color: #9074bf;
      font-size: 12px;
      font-weight: bold;
      margin: 0 0 4px 0;
      display: block;
    }

    .infoValue {
      color: #4b4b4b;
      font-size: 14px;
    }
  }
`;
